<template>
  <div class="districtModal">
    <div class="info">
      <div class="info-title">
        {{ $t('checkout.Number', [tableType]) }}
        <b class="text-negative">*</b>
      </div>
      <MTooltip :text="$t('checkout.NumberTip', { v1: tableType })">
        <q-icon name="app:tipsIcon" class="logo" size="16px" />
      </MTooltip>
      <div v-if="localTable" class="info-number">{{ localTable }}</div>
    </div>
    <MInput
      v-if="isDine && !localTable"
      v-model="tableNumber"
      :max="isRoomService ? 30 : 5"
      :class="[{ warn: isNormalDineIn && invalidTable }]"
      @keydown.enter.prevent
      @blur="options = []"
      @focus="options = backOptions"
    />
    <div
      v-if="!tableNumber && !localTable"
      class="user-form-err"
    >{{ $t('checkout.inputTableNumber') }}</div>
    <template v-if="isNormalDineIn && !localTable">
      <div
        v-if="invalidTable && tableNumber"
        class="err-text"
      >{{ $t('checkout.notfoundTable', { v1: tableType }) }}</div>
      <div v-if="filtered.length" class="option-wrap">
        <div
          v-for="item in filtered"
          :key="item"
          class="table-text"
          @mousedown="() => (tableNumber = item)"
        >{{ item }}</div>
      </div>
    </template>
  </div>
</template>

<script>
import MTooltip from 'src/components/MTooltip.vue';
import MInput from 'src/components/MInput/index.vue';
import { getTableNumber } from 'src/api/checkout';
import { getTable } from 'src/utils/common';

export default {
  components: { MTooltip, MInput },
  data() {
    return {
      localTable: '',
      tableNumber: '',
      tableType: '',
      options: [],
      backOptions: [],
    };
  },
  computed: {
    filtered() {
      if (!this.tableNumber) return [];
      return this.options.filter((item) => {
        const res = item.toString().toLowerCase();
        return res.indexOf(`${this.tableNumber}`.toLowerCase()) > -1;
      });
    },
    invalidTable() {
      const table = this.tableNumber || this.localTable;
      if (this.isRoomService) return table.length > 30 || !table;
      const find = this.backOptions.find((it) => it === table);
      return find === undefined;
    },
  },
  mounted() {
    this.localTable = getTable();
    this.tableNumber = this.localTable;
    if (this.isRoomService && this.isDine) this.localTable = '';
    this.tableType = this.$t(`list.table${this.storeInfo.businessType}`);
    getTableNumber({ keyword: '' }).then((res) => {
      this.options = JSON.parse(JSON.stringify(res.data));
      const numberReg = /^[0-9]*$/;
      const specialListReg = /^([a-z]*)(-|\s)(\d*)/i;
      const NumberList = [];
      const otherList = [];
      const specialList = [];
      this.options.forEach((item) => {
        if (numberReg.test(item)) {
          NumberList.push(item);
        } else if (specialListReg.test(item)) {
          specialList.push(item);
        } else {
          otherList.push(item);
        }
      });
      const sorterNumber = (a, b) => Number(a) - Number(b);
      NumberList.sort(sorterNumber);
      const sortFn = (a, b) => {
        const regex = /^([a-z]*)(\d*)/i;
        const next = a.match(regex);
        const last = b.match(regex);
        if (next[1] < last[1]) {
          return -1;
        }
        if (next[1] > last[1]) {
          return 1;
        }
        const list = parseInt(next[2], 10) - parseInt(last[2], 10);
        return list;
      };
      const sortSpecialListFn = (a, b) => {
        const regex = /^([a-z]*)(-|\s)(\d*)/i;
        const next = a.match(regex);
        const last = b.match(regex);
        if (next[2] < last[2]) {
          return -1;
        }
        if (next[2] > last[2]) {
          return 1;
        }
        const list = parseInt(next[3], 10) - parseInt(last[3], 10);
        return list;
      };
      otherList.sort(sortFn);
      specialList.sort(sortSpecialListFn);
      this.options = specialList.concat(otherList).concat(NumberList);
      this.backOptions = [...this.options];
    });
  },
};
</script>

<style lang="scss" scoped>
.districtModal {
  .option-wrap {
    background: #ffffff;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.05);
    border-radius: 6px;
    margin-top: 8px;
    padding: 0 16px;
    max-height: 258px;
    overflow-y: scroll;
    .table-text {
      font-family: Montserrat;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 18px;
      color: $dark;
      padding: 16px 0;
      border-bottom: 1px solid #f3f4f6;
    }
  }
  .err-text {
    font-family: Montserrat;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 120%;
    color: $negative;
    margin-top: 8px;
  }
}
.warn {
  :deep(.minput-input) {
    border: 1px solid $negative;
  }
}
.user-form-err {
  font-size: 12px;
  line-height: 120%;
  color: $negative;
  margin-top: 8px;
}

// =====
.info {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  .info-number {
    margin-left: auto;
    color: $primary;
    font-weight: 700;
    font-size: 18px;
  }
  .info-title {
    font-weight: bold;
    font-size: 12px;
    margin-right: 4px;
  }
}
</style>
